var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeDetail active" },
    [
      _c(
        "van-cell-group",
        { staticClass: "info" },
        [
          _c("van-cell", { attrs: { title: "客户名称" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.customerName))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "客户电话" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.phone))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "客户性别" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.gender))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "客户类型" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.customerType))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "客户人数" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.visitCnt))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "到店时间" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("getTime")(_vm.traffic.dateFrom)) +
                  " - " +
                  _vm._s(_vm._f("getTime")(_vm.traffic.dateTo)) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "年龄区间" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.estimateAge))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "所在城市" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(
                _vm._s(_vm.traffic.provinceName) +
                  " " +
                  _vm._s(_vm.traffic.cityName)
              )
            ])
          ]),
          _vm._v(" "),
          _c("van-switch-cell", {
            attrs: {
              title: "是否试机",
              "active-color": "#ff4040",
              "inactive-color": "#000000",
              "active-value": "1",
              "inactive-value": "0",
              disabled: ""
            },
            model: {
              value: _vm.traffic.test,
              callback: function($$v) {
                _vm.$set(_vm.traffic, "test", $$v)
              },
              expression: "traffic.test"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.traffic.test === "1",
                  expression: "traffic.test === '1'"
                }
              ]
            },
            [
              _c("van-panel", { attrs: { title: "试机产品" } }, [
                _c("p", { staticClass: "item2 margin-left0_4" }, [
                  _vm._v(_vm._s(_vm.traffic.testProducts))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("van-switch-cell", {
            attrs: {
              title: "是否购机",
              "active-color": "#ff4040",
              "inactive-color": "#000000",
              "active-value": "1",
              "inactive-value": "0",
              disabled: ""
            },
            model: {
              value: _vm.traffic.buy,
              callback: function($$v) {
                _vm.$set(_vm.traffic, "buy", $$v)
              },
              expression: "traffic.buy"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.traffic.buy === "1",
                  expression: "traffic.buy === '1'"
                }
              ]
            },
            [
              _c("van-panel", { attrs: { title: "购机产品" } }, [
                _c("p", { staticClass: "item2 margin-left0_4" }, [
                  _vm._v(_vm._s(_vm.traffic.buyProduct))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.traffic.buy === "0",
                  expression: "traffic.buy === '0'"
                }
              ]
            },
            [
              _c("van-panel", { attrs: { title: "未成交原因" } }, [
                _c("p", { staticClass: "item2 margin-left0_4" }, [
                  _vm._v(_vm._s(_vm.traffic.reason))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("van-panel", { attrs: { title: "备注" } }, [
            _c("p", { staticClass: "item2 margin-left0_4" }, [
              _vm._v(_vm._s(_vm.traffic.remark))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group", attrs: { title: "系统信息" } },
        [
          _c("van-cell", { attrs: { title: "销售顾问" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.salesaman))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "所属门店" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.deptName))
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "创建时间" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(_vm._s(_vm.traffic.createdTime))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-btn flex" }, [
        _vm.traffic.status === "0" &&
        _vm.viewer === _vm.traffic.createdId &&
        _vm.hasTrafficModified
          ? _c(
              "div",
              { staticClass: "item1 btn save", on: { click: _vm.edit } },
              [_vm._v("\n      编辑\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.traffic.status === "0" &&
        _vm.viewer === _vm.traffic.createdId &&
        _vm.hasTrafficModified
          ? _c(
              "div",
              { staticClass: "item1 btn sub", on: { click: _vm.submit } },
              [_vm._v("\n      提交\n    ")]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb136bca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb136bca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/viewCustomerTraffic.vue
// module id = null
// module chunks = 